import { render, staticRenderFns } from "./NavigationAccount.vue?vue&type=template&id=6a74799d"
import script from "./NavigationAccount.vue?vue&type=script&lang=js"
export * from "./NavigationAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports